import classnames from 'classnames';
import { head } from 'ramda';
import React, { FC } from 'react';
import { useVideoPreviews } from '../../../../../../utils/media-manager-sdk/hooks';
import { getExtension } from '../../../../../../utils/path';
import { IFileThumbnail } from '../../../../../common/Thumbnails/types';
import styles from '../ListFileThumbnail.scss';
import { ListFileThumbnailLabel } from '../ListFileThumbnailLabel';
import { ListFileThumbnailNotReadyGuard } from '../ListFileThumbnailNotReadyGuard';

export const Video: FC<IFileThumbnail> = ({
  file,
  className,
  dataHook,
  controlsClassName,
  labelClassName,
  onPlayClick,
}) => {
  const videoSrc = head(useVideoPreviews(file));

  return (
    <div className={className} data-hook={dataHook}>
      <ListFileThumbnailNotReadyGuard item={file}>
        <>
          <ListFileThumbnailLabel
            className={classnames(styles.label, labelClassName)}
            label={`.${getExtension(videoSrc)}`}
          />
          <div className={classnames(styles.controls, controlsClassName)}>
            <div className={styles.playButton} onClick={onPlayClick} data-hook="video-play-button" />
          </div>
        </>
      </ListFileThumbnailNotReadyGuard>
    </div>
  );
};
